import { useState, useEffect } from 'react';
import apiFetch from "./../apiClient";

interface Income {
  id: string;
  amount: number;
  category: string;
  date: string;
  description: string;
  paymentMethod: string;
}

const PAYMENT_METHODS = ['Dinheiro', 'Débito', 'Crédito', 'PIX', 'Transferência'];

export function AddIncomeCard({categories, defaultMonth, defaultYear, editingIncome, onSaved, onCancel}) {
    const defaultDate = `${defaultYear}-${String((defaultMonth ?? new Date().getMonth()) + 1).padStart(2,'0')}-01`;
    const [incomeForm, setIncomeForm] = useState({ amount:'', displayAmount:'', category:'', date: defaultDate, description:'', paymentMethod:'' });
    const [error, setError] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);

    useEffect(() => {
        if (editingIncome) {
            setIncomeForm({
                amount: editingIncome.transacao_valor,
                displayAmount: String(editingIncome.transacao_valor),
                category: editingIncome.categoria_id,
                date: (editingIncome.transacao_data || '').slice(0, 10),
                description: editingIncome.transacao_descricao || '',
                paymentMethod: editingIncome.transacao_forma_de_pagamento || ''
            });
        }
    }, [editingIncome]);

    const addIncomes = async () => {
        const createIncome: Income = {
            id: Date.now().toString(),
            amount: parseFloat(incomeForm.amount),
            category: incomeForm.category,
            date: incomeForm.date,
            description: incomeForm.description || null,
            payment_method: incomeForm.paymentMethod || null
        };
        setIsProcessing(true);
        setError(null);
        try {
            if (editingIncome) {
                await apiFetch(`/api/financecontrol/update-income/${editingIncome.transacao_id}`, {
                    method: "PUT",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(createIncome),
                });
            } else {
                await apiFetch("/api/financecontrol/create-income", {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(createIncome),
                });
            }
            resetIncomeForm();
            await onSaved?.();
        } catch (err) {
            setError(err.message);
        } finally {
            setIsProcessing(false);
        }
    };

    const resetIncomeForm = () => {
        setIncomeForm({
            amount: '',
            displayAmount: '',
            category: '',
            date: '',
            description: '',
            paymentMethod: ''
        });
    };

    const handleAmountChange = (e) => {
        const valorOriginal = e.target.value;
        const valorTratado = valorOriginal.replace(/[^0-9,.]/g, ''); 
        const valorNumerico = valorTratado.replace(/\./g, '').replace(',', '.');

        setIncomeForm({ 
            ...incomeForm, 
            // Armazena a string que será exibida no input (ex: "1.234,56")
            displayAmount: valorTratado, 
            // Armazena o valor que será enviado para o backend/cálculo (ex: 1234.56)
            amount: parseFloat(valorNumerico) || 0 
        });
    }
    return (
        <div className="row g-3">
            <div className="col-12">
                <label htmlFor="income-category" className="form-label text-muted-custom small">Categoria</label>
                <select
                    id="income-category"
                    className="form-select form-select-custom"
                    value={incomeForm ? incomeForm.category : ''}
                    onChange={(e) => setIncomeForm({ ...incomeForm, category: e.target.value})}
                    onFocus={(e) => e.target.style.borderColor = 'var(--color-primary)'}
                    onBlur={(e) => e.target.style.borderColor = 'var(--color-border)'}
                >
                    <option value="" disabled>Categoria</option>
                    {categories && categories.filter(cat => cat.categoria_tipo === 'credito').map((category) => (
                        <option key={category.categoria_id} value={category.categoria_id}>{category.categoria_nome}</option>
                    ))}
                </select>
                {/* <input
                    type="text"
                    className="form-control"
                    placeholder="e.g., Employment, Investment"
                    value={incomeForm != null ? incomeForm.category : ''}
                    onChange={(e) => setIncomeForm({ ...incomeForm, category: e.target.value })}
                    style={{
                        backgroundColor: 'var(--color-surface)',
                        border: '1px solid var(--color-border)',
                        color: 'var(--color-text-primary)',
                        padding: '0.75rem 1rem',
                        borderRadius: '0.5rem'
                    }}
                    onFocus={(e) => e.target.style.borderColor = 'var(--color-primary)'}
                    onBlur={(e) => e.target.style.borderColor = 'var(--color-border)'}
                /> */}
            </div>
            <div className="col-12">
                <label className="form-label text-muted-custom small">Valor</label>
                <div className="input-group">
                    <span 
                        className="input-group-text" 
                        style={{ 
                        backgroundColor: 'var(--color-surface)', 
                        border: '1px solid var(--color-border)',
                        borderRight: 'none',
                        color: 'var(--color-text-secondary)' 
                        }}
                    >
                        R$
                    </span>
                    <input
                        // type="number"
                        type='text'
                        // step="0.01"
                        className="form-control"
                        placeholder="0,00"
                        // value={incomeForm != null ? incomeForm.amount : ''}
                        value={incomeForm != null ? incomeForm.displayAmount : ''}
                        // onChange={(e) => setIncomeForm({ ...incomeForm, amount: e.target.value })}
                        onChange={handleAmountChange}
                        style={{
                            backgroundColor: 'var(--color-surface)',
                            border: '1px solid var(--color-border)',
                            borderLeft: 'none',
                            color: 'var(--color-text-primary)',
                            padding: '0.75rem 1rem',
                            borderRadius: '0 0.5rem 0.5rem 0'
                        }}
                        onFocus={(e) => e.target.style.borderColor = 'var(--color-primary)'}
                        onBlur={(e) => e.target.style.borderColor = 'var(--color-border)'}
                    />
                </div>
            </div>
            <div className="col-12">
                <label className="form-label text-muted-custom small">Data de Recebimento</label>
                <input
                    type="date"
                    className="form-control"
                    value={incomeForm != null ? incomeForm.date : ''}
                    onChange={(e) => setIncomeForm({ ...incomeForm, date: e.target.value })}
                    style={{
                        backgroundColor: 'var(--color-surface)',
                        border: '1px solid var(--color-border)',
                        color: 'var(--color-text-primary)',
                        padding: '0.75rem 1rem',
                        borderRadius: '0.5rem'
                    }}
                    onFocus={(e) => e.target.style.borderColor = 'var(--color-primary)'}
                    onBlur={(e) => e.target.style.borderColor = 'var(--color-border)'}
                />
            </div>
            <div className="col-12">
                <label htmlFor="income-description" className="form-label text-muted-custom small">Descrição (opcional)</label>
                <input
                    id="income-description"
                    type="text"
                    className="form-control"
                    placeholder="Ex: 13º salário"
                    value={incomeForm != null ? incomeForm.description : ''}
                    onChange={(e) => setIncomeForm({ ...incomeForm, description: e.target.value })}
                    style={{
                        backgroundColor: 'var(--color-surface)',
                        border: '1px solid var(--color-border)',
                        color: 'var(--color-text-primary)',
                        padding: '0.75rem 1rem',
                        borderRadius: '0.5rem'
                    }}
                    onFocus={(e) => e.target.style.borderColor = 'var(--color-primary)'}
                    onBlur={(e) => e.target.style.borderColor = 'var(--color-border)'}
                />
            </div>
            <div className="col-12">
                <label htmlFor="income-payment-method" className="form-label text-muted-custom small">Forma de recebimento (opcional)</label>
                <select
                    id="income-payment-method"
                    className="form-select form-select-custom"
                    value={incomeForm != null ? incomeForm.paymentMethod : ''}
                    onChange={(e) => setIncomeForm({ ...incomeForm, paymentMethod: e.target.value })}
                    onFocus={(e) => e.target.style.borderColor = 'var(--color-primary)'}
                    onBlur={(e) => e.target.style.borderColor = 'var(--color-border)'}
                >
                    <option value="">Não informado</option>
                    {PAYMENT_METHODS.map((method) => (
                        <option key={method} value={method}>{method}</option>
                    ))}
                </select>
            </div>
            <div className="col-12">
                <div className="d-flex gap-2 justify-content-end">
                    <button
                        className="btn btn-outline-custom"
                        onClick={() => {
                            resetIncomeForm();
                            onCancel?.();
                        }}
                    >
                        Cancelar
                    </button>
                    <button
                        className="btn btn-primary-custom"
                        onClick={addIncomes}
                        disabled={isProcessing}
                    >
                        {editingIncome ? 'Atualizar' : 'Adicionar'} Renda
                    </button>
                </div>
                {error && (
                    <small className="text-danger-custom d-block mt-1 text-end">{error}</small>
                )}
            </div>
        </div>
    );
}